import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { CANCELLATION_NOTE_MAX } from '@/scheduling/lib/cancellation-note';

interface CancellationNoteFieldProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

/**
 * Optional free-text "Note" for a single-appointment cancel. Shared by the
 * calendar cancel dialog and the patient Appointments-tab cancel dialog so the
 * limit and counter cannot drift between them.
 */
export function CancellationNoteField({
  value,
  onChange,
  disabled,
}: CancellationNoteFieldProps) {
  return (
    <div className="space-y-2">
      <Label htmlFor="cancel-note" className="text-sm font-semibold text-text-primary">
        Note (optional)
      </Label>
      <Textarea
        id="cancel-note"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        maxLength={CANCELLATION_NOTE_MAX}
        rows={3}
        disabled={disabled}
        placeholder="Add a note about this cancellation"
      />
      <p className="text-xs text-text-hint text-right">
        {value.length}/{CANCELLATION_NOTE_MAX}
      </p>
    </div>
  );
}
